import { URLS } from '../constants'
import { dispatchFetchGet } from './ActionsUtil'
import {
  GET_SEARCH_EMAIL_BEGIN, GET_SEARCH_EMAIL_SUCCESS, GET_SEARCH_EMAIL_FAILURE,
  GET_SEARCH_CNPJ_BEGIN, GET_SEARCH_CNPJ_SUCCESS, GET_SEARCH_CNPJ_FAILURE
} from '../constants/ActionTypes'

// Get Customer By Email
const acGetCustomerByEmailBegin = () => ({ type: GET_SEARCH_EMAIL_BEGIN })
const acGetCustomerByEmailSuccess = payload => ({
  type: GET_SEARCH_EMAIL_SUCCESS, payload
})
const acGetCustomerByEmailFailure = err => ({
  type: GET_SEARCH_EMAIL_FAILURE, payload: { error: err }
})

export const acGetCustomerByEmail = (email) => {
  return dispatchFetchGet(
    `${URLS.CUSTOMER_SEARCH.EMAIL}/${email}`,
    acGetCustomerByEmailBegin,
    acGetCustomerByEmailSuccess,
    acGetCustomerByEmailFailure,
  )
}


// Get Customers By CNPJ
const acGetCustomersByCnpjBegin = () => ({ type: GET_SEARCH_CNPJ_BEGIN })
const acGetCustomersByCnpjSuccess = payload => ({
  type: GET_SEARCH_CNPJ_SUCCESS, payload
})
const acGetCustomersByCnpjFailure = err => ({
  type: GET_SEARCH_CNPJ_FAILURE, payload: { error: err }
})

export const acGetCustomersByCnpj = (cnpj) => {
  return dispatchFetchGet(
    `${URLS.CUSTOMER_SEARCH.CNPJ}/${cnpj}`,
    acGetCustomersByCnpjBegin,
    acGetCustomersByCnpjSuccess,
    acGetCustomersByCnpjFailure,
  )
}